<template>
  <div class="content">
    <div class="header" v-for="(item,index) in info" :key="index">
      <h6>{{item.title}}</h6>
      <p v-for="(i,j) in item.content" :key="j" v-html="i"></p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      info: [
        {
          title: "“探店吃喝玩乐”隐私政策",
          content: [
            "广州渠道无忧网络技术服务有限公司及其关联方（简称“我们”）作为探店吃喝玩乐的运营者，深知个人信息对您的重要性，我们将按照法律法规的规定，保护您的个人信息及隐私安全。我们制定本“隐私政策”并特别提示：希望您在使用探店吃喝玩乐及相关服务前仔细阅读并理解本隐私政策，以便做出适当的选择。"
          ]
        },
        {
          title: "本隐私政策将帮助您了解：",
          content: [
            "我们会遵循隐私政策收集、使用您的信息，但不会仅因您同意本隐私政策而采用强制捆绑的方式一揽子收集个人信息。",
            "当您使用或开启相关功能或使用服务时，为实现功能、服务所必需，我们会收集、使用相关信息。除非是为实现基本业务功能或根据法律法规要求所必需的必要信息，您均可以拒绝提供且不影响其他功能或服务。我们将在隐私政策中逐项说明哪些是必要信息。",
            "如果您未登录帐号，我们会通过设备对应的标识符信息来保障信息推送的基本功能。如果您登录了帐号，我们会根据帐号信息实现信息推送。",
            "精确地理位置、摄像头、麦克风、相册权限，均不会默认开启，只有经过您的明示授权才会在为实现特定功能或服务时使用。特别需要指出的是，即使经过您的授权，我们获得了这些敏感权限，也不会在相关功能或服务不需要时而收集您的信息。",
            "本隐私政策适用于您通过探店吃喝玩乐应用程序、探店吃喝玩乐官方网站、供第三方网站和应用程序使用的探店吃喝玩乐软件开发工具包（SDK）和应用程序编程接口（API）方式来访问和使用我们的产品和服务。",
            "下文将帮您详细了解我们如何收集、使用、存储、传输、共享、转让（如适用）与保护个人信息；帮您了解查询、访问、删除、更正个人信息的方式。其中，有关您个人信息权益的条款重要内容我们已用加粗形式提示，请特别关注。",
            "1.我们如何收集和使用个人信息",
            "2.我们如何使用Cookie等同类技术",
            "3.我们如何共享、转让、公开披露个人信息",
            "4.我们如何存储个人信息",
            "5.我们如何保护个人信息的安全",
            "6.管理您的个人信息",
            "7.未成年人条款",
            "8.隐私政策的修订和通知",
            "9.联系我们"
          ]
        },
        {
          title: "1.我们如何收集和使用个人信息",
          content: [
            "我们会按照如下方式收集您在使用服务时主动提供的，以及通过自动化手段收集您在使用功能或接受服务过程中产生的信息： ",
            "1.1 注册、登录、认证",
            " 1.1.1 注册、登录帐号",
            "a.当您注册、登录探店吃喝玩乐及相关服务时，您可以通过手机号创建帐号，并且您可以完善相关的网络身份识别信息（头像、昵称），收集这些信息是为了帮助您完成注册。您还可以根据自身需求选择填写性别、生日、地区及个人介绍来完善您的信息。",
            "b.您也可以使用第三方帐号登录并使用探店吃喝玩乐，您将授权我们获取您在第三方平台注册的公开信息（头像、昵称以及您授权的其他信息），用于与探店吃喝玩乐帐号绑定，使您可以直接登录并使用本产品和相关服务。在使用第三方账号进行登录时，可能需要将实现登录所必需的信息在剪切板中写入与读取。这些信息仅供实现登录相关的目的所使用，不会收集您的隐私信息。",
            "1.1.2 认证",
            "在您使用身份认证的功能或相关服务所需时，根据相关法律法规，您可能需要提供您的真实身份信息（真实姓名、身份证号码、电话号码等）以完成实名验证。 部分信息属于个人敏感信息，您可以拒绝提供，如果拒绝提供您将可能无法获得相关服务，但不影响其他功能与服务的正常使用。",
            "1.2 播放浏览",
            "a.为保障推荐内容的质量并向您推荐可能感兴趣的视频及相关信息，探店吃喝玩乐可能会收集相关必要的日志信息。",
            "b.上述日志信息包括：",
            "您操作、使用的行为信息：点击、关注、收藏、搜索、浏览、分享",
            "您主动提供的信息：反馈、发布、点赞（喜欢）、评论",
            "地理位置信息：含通过GPS信息、WLAN接入点、蓝牙和基站等传感器信息获取到的精确地理位置信息及通过网络位置信息（例如基站、IP及WLAN）获取的大致地理位置信息",
            "c.精确地理位置信息是个人敏感信息，若您拒绝提供，我们将不会根据精确地理位置信息向您推荐信息，且不会影响探店吃喝玩乐其他功能的正常使用。",
            "d.我们会基于大致地理位置信息对应的城市及/或区县向您展示、推荐您所在地区（城市、区县等）的本地相关信息。",
            "1.3 发布与互动",
            "1.3.1 信息发布",
            "a.您发布音视频、图片等内容或进行评论时，我们将收集您发布的信息，并展示您的昵称、头像、发布内容和信息。",
            "b.您使用发布图片、音视频功能时，我们会请求您授权相机、照片、麦克风权限。您如果拒绝授权提供，将无法使用此功能，但不影响您正常使用探店吃喝玩乐的其他功能。",
            "c.您使用“同城”及相关服务或发布信息时，我们会请求您授权精确地理位置权限，并收集与本服务相关的位置信息，以帮助您在发布信息或互动时显示位置。您如果拒绝授权提供精确地理位置信息，我们会通过您的IP地址对应到您所在的城市及/或区县。如果您希望在作品中添加地理位置信息，您可以通过授权精确地理位置权限或主动选择的方式（搜索或平台推荐选项等）进行添加。",
            "d.用户因使用我们的产品或者服务而被我们收集的信息，例如其他用户发布的信息中可能含有您的部分信息（如：在评论、留言、发布图文、音视频中涉及到与您相关的信息）。",
            "e.我们非常重视用户的使用体验，为了提升音视频的上传速度、丰富发布功能和优化体验，当您发布音视频时，在点击“发布”确认上传之前，我们会将该音视频临时加载至服务器。如果您取消或因其他原因未成功上传，我们会立即删除相关音视频。",
            "f.我们还可能为向您提供人脸贴纸功能而在客户端本地使用仅供该功能的部分面部特征值信息，以提供更好的视觉效果，在此过程中，除非另有明确说明并征得您的同意，我们不会回传、储存或共享您的任何面部特征值信息。",
            "1.3.2 互动交流",
            "a.当您关注帐号、进行浏览、评论、关注（收藏）、喜欢（点赞）或分享时，我们会收集您关注的帐号和前述信息，并展示关注帐号发布内容。",
            "b.您可以在探店吃喝玩乐中添加或删除朋友，为帮您实现这一功能，我们会创建朋友列表信息。朋友列表是建立与管理朋友关系所必需的必要信息。",
            "c.当您选择使用扫码添加朋友时，探店吃喝玩乐可能会向您请求摄像头权限，摄像头权限是敏感权限，拒绝提供仅会使您无法通过扫码途径添加朋友，不影响其他功能的使用。",
            "1.3.3 消息通知",
            "您知悉并同意，对于您在使用产品及/或服务的过程中提供的您的联系方式（例如：联系电话），我们在运营中可能会向其中的一种或多种发送多类通知，用于用户消息告知、身份验证、安全验证、用户使用体验调研等用途；此外，我们也可能会以短信、电话的方式，为您提供您可能感兴趣的服务、功能或活动等商业性信息的用途，但请您放心，如您不愿接受这些信息，您可以通过手机短信中提供的退订方式进行退订，也可以直接与我们联系进行退订。",
            "1.4 搜索",
            "您使用探店吃喝玩乐的搜索服务时，我们会收集您的搜索关键字信息、日志记录。为了提供高效的搜索服务，部分前述信息会暂时存储在您的本地存储设备之中，并可向您展示搜索结果内容、搜索历史记录。",
            "1.5 运营与安全运行",
            "1.5.1 运营与安全保障",
            "我们致力于为您提供安全、可信的产品与使用环境，提供优质而可靠的服务与信息是我们的核心目标。",
            "1.5.2 设备信息与日志信息",
            "a.为了保障软件与服务的安全运行、运营的质量及效率，我们会收集您的硬件型号、操作系统版本号、国际移动设备识别码、唯一设备标识符、网络设备硬件地址、IP 地址、WLAN接入点、蓝牙、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志。",
            "b.为了预防恶意程序、保障运营质量及效率，我们会收集安装的应用信息或正在运行的进程信息、应用程序的总体运行、使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源。",
            "c.我们可能使用您的账户信息、设备信息、服务日志信息以及我们关联方、合作方在获得您授权或依法可以共享的信息，用于判断账户安全、进行身份验证、检测及防范安全事件。",
            "1.6 分享与活动参与",
            "在您分享或接收被分享的信息、参加活动等情形下，我们需要访问您的剪切板，读取其中包含的口令、分享码、链接，以实现跳转、分享、活动联动等功能或服务。",
            "1.7 统计分析",
            "为了分析应用新增、激活、留存、性能等统计性指标，我们可能会调用剪切板对相关统计信息进行归因分析，请您放心，我们不会收集您的隐私信息。",
            "1.8 收集、使用个人信息目的变更",
            "请您了解，随着我们业务的发展，可能会对探店吃喝玩乐的功能和提供的服务有所调整变化。原则上，当新功能或服务与我们当前提供的功能或服务相关时，收集与使用的个人信息将与原处理目的具有直接或合理关联。在与原处理目的无直接或合理关联的场景下，我们收集、使用您的个人信息，会再次进行告知，并征得您的同意。",
            "1.9 依法豁免征得同意收集和使用的个人信息",
            "请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息无需征得您的授权同意：",
            "a.与国家安全、国防安全直接相关的；",
            "b.与公共安全、公共卫生、重大公共利益直接相关的；",
            "c.与犯罪侦查、起诉、审判和判决执行等直接相关的；",
            "d.出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；",
            "e.所收集的您的个人信息是您自行向社会公众公开的；",
            "f.从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；",
            "g.根据您的要求签订或履行合同所必需的；",
            "h.用于维护软件及相关服务的安全稳定运行所必需的，例如发现、处置软件及相关服务的故障；",
            "i.为合法的新闻报道所必需的；",
            "j.学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；",
            "k.法律法规规定的其他情形。",
            "特别提示您注意，如信息无法单独或结合其他信息识别到您的个人身份，其不属于法律意义上您的个人信息；当您的信息可以单独或结合其他信息识别到您的个人身份时或我们将无法与任何特定个人信息建立联系的数据与其他您的个人信息结合使用时，这些信息在结合使用期间，将作为您的个人信息按照本隐私政策处理与保护。",
          ]
        },
        {
          title: "2.我们如何使用Cookie等同类技术",
          content: [
            "Cookie和设备信息标识等同类技术是互联网中普遍使用的技术。当您使用探店吃喝玩乐及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie 或匿名标识符，以收集、标识您访问、使用本产品时的信息。我们承诺，不会将Cookie 用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie 和同类技术主要为了实现以下功能或服务：",
            "2.1 保障产品与服务的安全、高效运转",
            "我们可能会设置认证与保障安全性的Cookie 或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。",
            "2.2 帮助您获得更轻松的访问体验",
            "使用此类技术可以帮助您省去重复您填写个人信息、输入搜索内容的步骤和流程（示例：记录搜索、表单填写）。",
            "2.3 为您推荐、展示、推送您可能感兴趣的内容或帐号",
            "a.我们可能会利用此类技术了解您的偏好和使用习惯，进行数据分析，以改善产品服务、推荐用户感兴趣的信息或功能，并优化您对广告的选择。",
            "b.在探店吃喝玩乐的分享页中，我们可能会使用Cookie对浏览活动进行记录，用于向您推荐信息和排查崩溃、延迟的相关异常情况以及探索更好的服务方式。",
            "2.4 Cookie的清除",
            "大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。如您进行清除，您可能无法使用由我们提供的、依赖于Cookie的服务或相应功能。"
          ]
        },
        {
          title: "3.我们如何共享、转让、公开披露个人信息",
          content: [
            "3.1共享",
            "3.1.1 共享原则",
            "a.授权同意原则： 未经您的同意，我们不会共享您的个人信息，除非共享的个人信息是去标识化处理后的信息，且共享第三方无法重新识别此类信息的自然人主体。如果第三方使用信息的目的超越原授权同意范围，他们需要重新征得您的同意。",
            "b.合法正当与最小必要原则： 共享的数据必须具有合法正当目的，且共享的数据以达成目的必要为限。",
            "c.安全审慎原则： 我们将审慎评估第三方使用共享信息的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全。",
            "<a style='color:#4F83E2;' href='/sdk-notice'>接入第三方SDK目录</a>",
            "3.1.2 实现功能或服务的共享信息",
            "a.当您在使用探店吃喝玩乐中由我们的关联方、第三方提供的功能，或者当软件服务提供商、智能设备提供商、系统服务提供商与我们联合为您提供服务时我们会将实现业务所必需的信息与这些关联方、第三方共享，用于综合统计并通过算法做特征与偏好分析，形成间接人群画像，用以向您进行推荐、展示或推送您可能感兴趣的信息，或者推送更适合您的特定功能、服务或商业广告。",
            "b.地理位置服务：当您使用地理位置相关服务时，我们会通过SDK或相关技术将GPS信息与位置服务提供商（百度地图）进行共享以便可以向您返回位置结果。GPS信息是个人敏感信息，拒绝提供，仅会影响地理位置服务功能，但不影响其他功能的正常使用。",
            "c.钱包功能：钱包功能中的相关服务由我们的关联方及合作伙伴提供，当您使用钱包相关功能时我们的关联方和合作伙伴会根据功能或服务必需而收集必要限度内的信息。",
            "d.支付功能：支付功能由与我们合作的第三方支付机构向您提供服务。第三方支付机构可能需要收集您的姓名、银行卡类型及卡号、有效期及手机号码。银行卡号、有效期及手机号码 是个人敏感信息，这些信息是支付功能所必需的信息，拒绝提供将导致您无法使用该功能，但不影响其他功能的正常使用。",
            "e.订单功能：当您使用探店吃喝玩乐订单中心功能时，经过您的授权，我们可能会与下单的相关服务提供方共享您的订单信息以方便您统一查询订单信息。",
            "f.为与您使用的终端机型适配消息推送功能，我们可能会通过SDK等技术与终端设备制造商（华为、小米、OPPO、VIVO等）共享手机型号、版本及相关设备信息。",
            "3.1.3 实现广告相关的共享信息",
            "a.广告推送与投放：我们可能与进行推广和广告投放的合作伙伴共享信息，但我们不会共享用于识别您个人身份的信息（姓名、身份证号），仅会向这些合作伙伴提供不能识别您个人身份的间接画像标签及去标识化的设备信息或匿名化后的设备、网络、渠道等信息，以帮助其在不识别您个人身份的前提下提升广告有效触达率。",
            "b.广告统计：我们可能与业务的服务商、供应商和其他合作伙伴共享分析去标识化的设备信息或统计信息，这些信息难以或无法与您的真实身份相关联。这些信息将帮助我们分析、衡量广告和相关服务的有效性。",
            "3.1.4 实现安全与分析统计的共享信息",
            "a.保障使用安全：我们非常重视帐号、服务及内容安全，为保障您和其他用户的帐号与财产安全，使您和我们的正当合法权益免受不法侵害，我们和关联方或服务提供商可能会共享必要的设备、帐号及日志信息。",
            "b.分析产品使用情况：为分析我们服务的使用情况，提升用户使用的体验，可能会与关联方或第三方共享产品使用情况（崩溃、闪退）的统计性数据，这些数据难以与其他信息结合识别您的个人身份。",
            "c.学术研究与科研：为提升相关领域的科研能力，促进科技发展水平，我们在确保数据安全与目的正当的前提下，可能会与科研院所、高校等机构共享去标识化或匿名化的数据。",
            "3.1.5 帮助您参加营销推广活动",
            "当您选择参加我们及我们的关联方或第三方举办的有关营销活动时，可能需要您提供姓名、通信地址、联系方式、银行帐号等信息。其中部分信息是个人敏感信息，拒绝提供可能会影响您参加相关活动，但不会影响其他功能。只有经过您的同意，我们才会将这些信息与关联方或第三方共享，以保障您在联合活动中获得体验一致的服务，或委托第三方及时向您兑现奖励。",
            "3.2 转让",
            "a.我们不会转让您的个人信息给任何其他第三方，除非征得您的明确同意。",
            "b.随着我们业务的持续发展，我们将有可能进行合并、收购、资产转让，您的个人信息有可能因此而被转移。在发生前述变更时，我们将按照法律法规及不低于本隐私政策所载明的安全标准要求继受方保护您的个人信息，否则我们将要求继受方重新征得您的授权同意。",
            "3.3 公开展示",
            "a. 我们不会公开披露您的信息，除非遵循国家法律法规规定或者获得您的同意。我们公开披露您的个人信息会采用符合行业内标准的安全保护措施。",
            "b. 对违规帐号、欺诈行为进行处罚公告时，我们会披露相关帐号的信息。",
            "c.您公开发布的作品、动态、喜欢（点赞）将会在个人主页中展示。",
            "3.4 依法豁免征得同意共享、转让、公开披露的个人信息",
            "请您理解，在下列情形中，根据法律法规及国家标准，我们共享、转让、公开披露您的个人信息无需征得您的授权同意：",
            "a.与国家安全、国防安全直接相关的；",
            "b.与公共安全、公共卫生、重大公共利益直接相关的；",
            "c.与犯罪侦查、起诉、审判和判决执行等直接相关的；",
            "d.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；",
            "e.您自行向社会公众公开的个人信息；",
            "f.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。"
          ]
        },
        {
          title: "4.我们如何存储个人信息",
          content: [
            "4.1 存储地点",
            "我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循相关国家规定或者征求您的同意。",
            "4.2 存储期限",
            "我们仅在为提供探店吃喝玩乐及服务之目的所必需的期间内保留您的个人信息：您发布的信息、评论、喜欢（点赞）及相关信息，在您未撤回、删除或未注销帐号期间，我们会保留相关信息。超出必要期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。"
          ]
        },
        {
          title: "5.我们如何保护个人信息的安全",
          content: [
            "a.我们非常重视您个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护您的个人信息，防止您提供的个人信息被不当使用或在未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。",
            "b.我们会使用不低于行业同行的加密技术、匿名化处理及相关合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。",
            "c.我们会建立专门的安全部门、安全管理制度、数据安全流程保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息，并适时对数据和技术进行安全审计。",
            "d.尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。",
            "e.您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于不将自己的帐号及相关个人信息透露给他人等。",
            "f.我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止这些安全事件的影响和后果扩大。一旦发生用户信息安全事件（泄露、丢失）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已经采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们将及时将事件相关情况以推送通知、邮件、信函、短信及相关形式告知您，难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。",
            "g.您一旦离开探店吃喝玩乐及相关服务，浏览或使用其他网站、服务及内容资源，我们将没有能力和直接义务保护您在探店吃喝玩乐及相关服务之外的软件、网站提交的任何个人信息，无论您登录、浏览或使用上述软件、网站是否基于探店吃喝玩乐的链接或引导。"
          ]
        },
        {
          title: "6.管理您的个人信息",
          content: [
            "我们非常重视您对个人信息的管理，并尽全力保护您对于您个人信息的查询、访问、修改、删除、撤回同意授权、注销帐号、投诉举报以及设置隐私功能的相关权利，以使您有能力保障您的隐私和信息安全。",
            "6.1 自主选择控制个性化推荐信息",
            "6.1.1 自主决定接收信息",
            "我们的消息通知功能，如果你不想接收，可以在系统设置不提醒功能。",
            "6.1.2 自主订阅所需信息",
            "在关注中会根据您主动选择关注的帐号信息进行展示，您可以自主选择关注或取消关注。",
            "6.2 访问、删除、更正您的个人信息",
            "6.2.1 访问个人帐号信息",
            "您可以查询、访问您的头像、用户名、简介、性别、生日、地区，您可以在【我】-【编辑资料】进行查询、访问、更正。",
            "6.2.2 查询访问、更正、删除信息",
            "a.进入【我】-【作品】中访问、删除您发布的音视频信息",
            "b.进入【我】-【喜欢】中访问、删除您点赞（喜欢）的信息",
            "c.进入【关注】可以访问、查询关注的帐号信息，在关注列表点击相应帐号后的“已关注”按钮（如有）或进入相应关注帐号主页可以选择取消关注该帐号",
            "d.进入【我】访问探店吃喝玩乐号、探店吃喝玩乐码等信息、访问更正绑定的手机号、设置",
            "6.3 注销帐号",
            "您可以在【我】-【设置】-【注销账号】进行帐号注销。在您注销帐号前，我们将验证您的个人身份、安全状态、设备信息等。有关注销的流程和内容，请参见<a style='color:#4F83E2;' href='/logout-notice'>《探店吃喝玩乐注销须知》</a>。您知悉并理解，注销帐号的行为是不可逆的行为，当您注销帐号后，我们将删除有关您的相关信息或进行匿名化处理，但法律法规另有规定的除外。",
            "6.4 投诉举报",
            "您可以按照我们公示的制度进行投诉或举报。如果您认为您的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索，您可以在【我】-【设置】-【反馈与帮助】，进入用户反馈界面与我们联系。我们核查后会在30日内反馈您的投诉与举报。",
            "6.5 访问隐私政策",
            "a.您可以在注册页面，或者在登录个人帐号【我】-【设置】- 【隐私政策】查看本隐私政策的全部内容。",
            "b.请您了解，本隐私政策中所述的探店吃喝玩乐及相关服务可能会根据您所使用的手机型号、系统版本、软件应用程序版本、移动客户端等因素而有所不同。最终的产品和服务以您所使用的探店吃喝玩乐软件及相关服务为准。",
            "6.6 停止运营向您告知",
            "如我们停止运营，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对所持有的您的个人信息进行删除或匿名化处理。"
          ]
        },
        {
          title: "7.未成年人条款",
          content: [
            "7.1未成年人通用条款",
            "a.若您是未满18周岁的未成年人，在使用探店吃喝玩乐及相关服务前，应在您的父母或其他监护人监护、指导下共同阅读并同意本隐私政策。",
            "b.我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用、共享或披露未成年人的个人信息；如果我们发现在未事先获得可证实的父母或其他监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关信息。",
            "c.若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本隐私政策公示的联系方式与我们联系。"
          ]
        },
        {
          title: "8.隐私政策的修订和通知",
          content: [
            "a.为了给您提供更好的服务，探店吃喝玩乐及相关服务将不时更新与变化，我们会适时对本隐私政策进行修订，这些修订构成本隐私政策的一部分并具有等同于本隐私政策的效力，未经您明确同意，我们不会削减您依据当前生效的本隐私政策所应享受的权利。",
            "b.本隐私政策更新后，我们会在探店吃喝玩乐发出更新版本，以便您及时了解本隐私政策的最新版本。"
          ]
        },
        {
          title: "9.联系我们",
          content: [
            "如果您对个人信息保护问题有投诉、建议、疑问，您可以将问题发送至（ranmaoxian@dingtalk.com）"
          ]
        },
        {
          title: "政策更新日期：2021-11-04",
          content: []
        }
      ]
    };
  }
};
</script>
<style lang="scss">
.content .mail{
  color:#4F83E2;
}
</style>

<style lang="scss" scoped>
.content {
  margin-bottom: 100px;
  .header {
    padding: 0px 29px;
    h6 {
      font-size: 30px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      margin: 35px 0 10px 0;
    }
    p {
      // text-align: justify;
      font-size: 26px;
      font-weight: 400;
      line-height:40px;
      color: rgba(85, 85, 85, 1);
    }
  }
}
</style>